var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"dialog",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.close()}}},[_c('div',{staticClass:"dialog-content"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }